"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import { Clock } from "lucide-react";
import { motion } from "framer-motion";
import type { Assessment } from "@/features/assessment/types";
import type { AppLocale } from "@/core/i18n/config";
import { localizeHref } from "@/core/i18n/routing";
interface AssessmentGridCardProps {
  assessment: Assessment;
  locale: AppLocale;
  index: number;
}
export function AssessmentGridCard(t0) {
  const $ = _c(24);
  const {
    assessment,
    locale,
    index
  } = t0;
  const t1 = `/assessment/${assessment.slug}`;
  let t2;
  if ($[0] !== locale || $[1] !== t1) {
    t2 = localizeHref(locale, t1);
    $[0] = locale;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const href = t2;
  let t3;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      opacity: 0,
      y: 24
    };
    t4 = {
      opacity: 1,
      y: 0
    };
    t5 = {
      once: true
    };
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  const t6 = index % 3 * 0.08;
  let t7;
  if ($[6] !== t6) {
    t7 = {
      duration: 0.5,
      delay: t6
    };
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== assessment.imageUrl || $[9] !== assessment.title) {
    t8 = <div className="relative mb-4 h-28 w-28 shrink-0 overflow-hidden rounded-full border-2 border-border bg-muted shadow-sm transition-transform duration-300 group-hover:scale-105 sm:h-32 sm:w-32"><Image src={assessment.imageUrl} alt={assessment.title} fill={true} sizes="128px" className="object-cover" /></div>;
    $[8] = assessment.imageUrl;
    $[9] = assessment.title;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== assessment.title) {
    t9 = <h3 className="mb-2 font-heading text-sm leading-snug font-semibold text-foreground transition-colors duration-300 group-hover:text-primary sm:text-base">{assessment.title}</h3>;
    $[11] = assessment.title;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Clock className="h-3 w-3" />;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== assessment.durationLabel) {
    t11 = <span className="mb-3 flex items-center gap-1 text-[11px] text-muted-foreground">{t10}{assessment.durationLabel}</span>;
    $[14] = assessment.durationLabel;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== href) {
    t12 = <Link href={href} className="text-[11px] font-bold tracking-[0.14em] text-primary uppercase transition-colors duration-200 hover:text-primary/80">Take Assessment</Link>;
    $[16] = href;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t11 || $[19] !== t12 || $[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
    t13 = <motion.div initial={t3} whileInView={t4} viewport={t5} transition={t7} className="group flex flex-col items-center text-center">{t8}{t9}{t11}{t12}</motion.div>;
    $[18] = t11;
    $[19] = t12;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  return t13;
}